import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ConfigError } from './ConfigError';
import { initSupabase, loadPlatformConfig } from './lib/supabase';
import './index.css';

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

const root = createRoot(container);

async function bootstrap() {
  try {
    const config = await loadPlatformConfig();
    initSupabase(config);
    root.render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  } catch (error) {
    root.render(
      <ConfigError message={error instanceof Error ? error.message : String(error)} />,
    );
  }
}

void bootstrap();
